(function () {
  var cfgEl = document.getElementById('fitaz-wlr-pdp-analytics-config');
  if (!cfgEl) return;

  var CFG;
  try {
    CFG = JSON.parse(cfgEl.textContent);
  } catch (e) {
    return;
  }

  var GA4 = CFG.ga4_id || 'G-Y0VT2QGQW7';
  var COOKIE = 'wlr_pdp_ab';
  var STORAGE_KEY = 'wlr_pdp_ab';
  var CONTROL_TEMPLATE = CFG.control_template || 'newyear-level1';
  var VARIANT_TEMPLATE = CFG.variant_template || 'weight-loss-reset';
  var pendingAtcSource = null;
  var kozlerPatched = false;

  function readCookie(name) {
    try {
      var parts = document.cookie.split(';');
      for (var i = 0; i < parts.length; i++) {
        var chunk = parts[i].trim();
        if (chunk.indexOf(name + '=') === 0) {
          return decodeURIComponent(chunk.slice(name.length + 1));
        }
      }
    } catch (e) {}
    return '';
  }

  function readStorage() {
    try {
      var value = window.localStorage.getItem(STORAGE_KEY) || '';
      if (value === 'control' || value === 'variant') return value;
    } catch (e) {}
    return '';
  }

  function resolveArm() {
    if (window.__fitazWlrAb && (window.__fitazWlrAb.arm === 'control' || window.__fitazWlrAb.arm === 'variant')) {
      return window.__fitazWlrAb.arm;
    }
    var stored = readCookie(COOKIE);
    if (stored !== 'control' && stored !== 'variant') stored = readStorage();
    if (stored === 'control' || stored === 'variant') return stored;

    if (CFG.pdp_variant === 'control' || CFG.pdp_variant === 'variant') return CFG.pdp_variant;
    if (CFG.pdp_template === VARIANT_TEMPLATE) return 'variant';
    if (CFG.pdp_template === CONTROL_TEMPLATE) return 'control';
    return '';
  }

  function templateForArm(arm) {
    return arm === 'variant' ? VARIANT_TEMPLATE : CONTROL_TEMPLATE;
  }

  function resolvedContext() {
    var arm = resolveArm();
    if (arm !== 'control' && arm !== 'variant') return null;
    return {
      arm: arm,
      template: templateForArm(arm)
    };
  }

  function setUserProperties(ctx) {
    if (!ctx) return;
    if (typeof window.fitazWlrApplyAbAttribution === 'function') {
      window.fitazWlrApplyAbAttribution({ force: true });
      return;
    }
    if (typeof window.gtag !== 'function') return;
    try {
      window.gtag('set', 'user_properties', {
        wlr_pdp_template: ctx.template,
        wlr_pdp_variant: ctx.arm
      });
      window.__fitazWlrAb = { arm: ctx.arm, template: ctx.template };
    } catch (e) {}
  }

  function baseParams(extra) {
    var ctx = resolvedContext();
    return Object.assign(
      {
        send_to: GA4,
        pdp_template: ctx ? ctx.template : CFG.pdp_template,
        pdp_variant: ctx ? ctx.arm : CFG.pdp_variant,
        pdp_market: CFG.pdp_market,
        item_id: CFG.item_id
      },
      extra || {}
    );
  }

  function send(name, extra) {
    var ctx = resolvedContext();
    if (!ctx) return;
    setUserProperties(ctx);
    var params = baseParams(extra);
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, params);
      } else {
        window.dataLayer = window.dataLayer || [];
        var payload = { event: name };
        Object.keys(params).forEach(function (key) {
          payload[key] = params[key];
        });
        window.dataLayer.push(payload);
      }
    } catch (err) {}
  }

  function once(key) {
    try {
      if (sessionStorage.getItem(key)) return false;
      sessionStorage.setItem(key, '1');
      return true;
    } catch (e) {
      return true;
    }
  }

  function resolveAtcSource(el) {
    if (!el) return 'generic';
    if (el.hasAttribute('data-wlr-atc')) return 'wlr_plans';
    if (el.hasAttribute('data-perfect-match-atc')) return 'perfect_match_hero';
    if (el.className && String(el.className).indexOf('ai-add-to-cart-button') !== -1) return 'ai_block';
    return 'generic';
  }

  function patchFetch() {
    if (window.__fitazWlrFetchPatched) return;
    window.__fitazWlrFetchPatched = true;

    var prevFetch = window.fetch;
    if (typeof prevFetch !== 'function') return;

    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isAdd = url.indexOf('/cart/add') !== -1;

      return prevFetch.apply(this, arguments).then(function (res) {
        if (isAdd && res.ok && pendingAtcSource) {
          send('wlr_pdp_add_to_cart', { atc_source: pendingAtcSource });
          window.__fitazCartOpenSource = 'post_atc';
          pendingAtcSource = null;
        }
        return res;
      });
    };
  }

  function patchKozler() {
    if (kozlerPatched) return true;
    var k = window.KozlerCartDrawer;
    if (!k) return false;

    function wrap(method) {
      if (typeof k[method] !== 'function' || k['__fitaz' + method]) return;
      var original = k[method].bind(k);
      k['__fitaz' + method] = true;
      k[method] = function () {
        if (window.__fitazCartOpenSource === 'post_atc') {
          send('wlr_pdp_cart_open', { open_source: 'post_atc' });
          window.__fitazCartOpenSource = null;
        }
        return original.apply(this, arguments);
      };
    }

    wrap('open');
    wrap('openAndRefresh');
    kozlerPatched = true;
    return true;
  }

  function retryPatchKozler(attempt) {
    if (patchKozler()) return;
    if (attempt >= 40) return;
    window.setTimeout(function () {
      retryPatchKozler(attempt + 1);
    }, 100);
  }

  function init() {
    var ctx = resolvedContext();
    if (!ctx) return;

    setUserProperties(ctx);

    var viewKey = 'fitaz_wlr_pdp_view_' + ctx.arm;
    if (once(viewKey)) {
      send('wlr_pdp_view');
    }

    patchFetch();
    retryPatchKozler(0);

    document.addEventListener(
      'click',
      function (e) {
        var target = e.target;
        if (!target || !target.closest) return;

        var checkoutBtn = target.closest('[data-checkout-button]');
        if (checkoutBtn) {
          setUserProperties(ctx);
          if (typeof window.fitazWlrApplyAbAttribution === 'function') {
            window.fitazWlrApplyAbAttribution({ force: true });
          }
          var countEl = document.querySelector('[data-cart-count-value]');
          send('wlr_pdp_checkout_click', {
            cart_item_count: countEl ? parseInt(countEl.textContent, 10) || 0 : undefined
          });
          return;
        }

        var atcEl = target.closest(
          '[data-wlr-atc], [data-perfect-match-atc], button[class*="ai-add-to-cart-button"], button[name="add"]'
        );
        if (!atcEl || atcEl.closest('.kozler-cart')) return;
        pendingAtcSource = resolveAtcSource(atcEl);
      },
      true
    );
  }

  function retryInit(attempt) {
    if (resolvedContext()) {
      init();
      return;
    }
    if (attempt >= 20) return;
    window.setTimeout(function () {
      retryInit(attempt + 1);
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      retryInit(0);
    });
  } else {
    retryInit(0);
  }
})();
